import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateUtils } from '../../../utils/date.utils';

export const minDate = (dateString: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return DateUtils.isBefore(control.value, dateString) ? { mindate: 'Date avant date limite' } : null;
  }
}
